import GeckoLocation from 'services/gecko-location';
import { sortObjects } from 'utilities/sorter';
import { searchObjects } from 'utilities/searcher';

const GeckoPagination = {
  // Takes an object of options, generally you will only need to pass through the current page and order_by/sort.  It will then return a function that takes the items to paginate
  paginate({
    page = 1,
    per_page = 20,
    changePage = this.queryStringChangePage,
    order_by = undefined,
    sort = 'ASC',
    changeOrder = this.queryStringChangeOrder,
    sorter = sortObjects,
    searchTerm = '',
    searchKey = undefined,
    searchKeys = undefined,
    total_items = undefined,
  }) {
    return (items = []) => {
      const searched = searchTerm
        ? searchObjects(items, searchKeys || [searchKey], searchTerm)
        : items;
      const pagination = {
        total_items: total_items || searched.length,
        current_page: page,
        total_pages: Math.ceil(searched.length / per_page),
        changePage: changePage,

        order_by: order_by,
        sort: sort,
        changeOrder: changeOrder,
      };

      const sorted = order_by ? sorter(searched, order_by, sort) : searched;
      const offset = per_page * page - per_page;
      const displayedItems = sorted.slice(offset, offset + per_page);

      // If there is nothing on this page and we aren't on page 1 then we want to go to the next page with items
      if (displayedItems.length === 0 && page !== 1) {
        const nextPageWithItems = Math.ceil(sorted.length / per_page) || 1;
        changePage(nextPageWithItems);
      }

      return [displayedItems, pagination];
    };
  },
  queryStringChangePage(newPage = 1) {
    GeckoLocation.goTo(
      GeckoLocation.location.pathname,
      Object.assign({}, GeckoLocation.params, { page: newPage })
    );
  },
  queryStringChangeOrder(key) {
    let sort = GeckoLocation.params.sort === 'ASC' ? 'DESC' : 'ASC';
    return GeckoLocation.goTo(
      GeckoLocation.location.pathname,
      Object.assign({}, GeckoLocation.params, { order_by: key, sort: sort })
    );
  },
};

export default GeckoPagination;
